import { render, staticRenderFns } from "./DriverMessage.vue?vue&type=template&id=4fe59ac0"
import script from "./DriverMessage.vue?vue&type=script&lang=js"
export * from "./DriverMessage.vue?vue&type=script&lang=js"
import style0 from "./DriverMessage.vue?vue&type=style&index=0&id=4fe59ac0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports